<template>
    <div class="modal-preview">
        <div class="modal-preview__wrapper" :class="{ active: widthCalculated }">
            <div class="modal-preview__header">
                <slot name="header" />

                <button
                    @click="closeModal"
                    class="close modal-close modal-preview__close"
                >
                    <span>×</span>
                </button>
            </div>

            <div class="modal-preview__content">

                <tiny-slider
                    ref="previewSlider"
                    class="modal-preview__slider"
                    :arrow-keys="true"
                    :nav="false"
                    :autoplay="false"
                    :center="true"
                    :gutter="0"
                    :edge-padding="0"
                    :controls="true"
                    :start-index="activeSlideIdx"
                    :on-init="(initialized = true)"
                    :touch="true"
                    :mouse-drag="true"
                    @indexChanged="onIndexChange"
                >
                    <slot />
                </tiny-slider>
            </div>

            <div class="modal-preview__footer">
                <slot name="footer" />
            </div>
        </div>

        <div class="modal-backdrop" v-show="widthCalculated" />
    </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider'
import { modalMixin } from '@/mixins/modal'

export default {
    name: 'ModalPreview',

    mixins: [modalMixin],

    props: {
        activeSlideIdx: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            widthCalculated: false,
            initialized: false
        }
    },

    computed: {
        content() {
            return this.$store.getters.getPreviewContent
        }
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },

        async updateSliderWidth() {
            // const activeIdx = this.$refs.previewSlider.slider.getInfo().index

            // const content = this.$el.querySelector('.modal-preview__content')
            // const slide = this.$el.querySelector('.modal-preview__slider')
            //     .children[activeIdx]

            // const slideImg = slide.querySelector('img')
            // let newsSlideWidth = window.innerWidth
            // let newsSlideHeight = window.innerHeight

            // const pdf = slide.querySelector('.vue-pdf-embed')
            // console.log('pdf', pdf)

            // if (slideImg) {
            //     // wait for image to load and then get width
            //     if (slideImg.complete) {
            //         newsSlideWidth = slideImg.naturalWidth
            //         newsSlideHeight =
            //             content.offsetHeight -
            //             slideImg.offsetHeight +
            //             slideImg.naturalHeight
            //     } else {
            //         await new Promise(resolve => {
            //             slideImg.onload = () => {
            //                 newsSlideWidth = slideImg.naturalWidth
            //                 newsSlideHeight =
            //                     content.offsetHeight -
            //                     slideImg.offsetHeight +
            //                     slideImg.naturalHeight
            //                 resolve()
            //             }
            //         })
            //     }
            // }

            this.widthCalculated = true

            // this.$el
            //     .querySelector('.modal-preview__content')
            //     .style.setProperty(
            //         '--preview-width',
            //         `${Math.max(newsSlideWidth, 800)}px`
            //     )
            // this.$el
            //     .querySelector('.modal-preview__content')
            //     .style.setProperty('--preview-height', `${newsSlideHeight}px`)
        },

        onIndexChange() {
            this.updateSliderWidth()
        }
    },

    watch: {
        initialized() {
            this.updateSliderWidth()
        }
    },

    components: {
        TinySlider: VueTinySlider
    }
}
</script>

<style lang="scss">
.modal-preview {
    --preview-width: auto;
    --preview-height: auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;

    &__close.modal-close {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
    }

    &__wrapper {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, calc(-50% - 15px));
        background-color: var(--color-white);
        border-radius: var(--border-radius);
        overflow: hidden;
        max-width: 95vw;
        max-height: 95vh;
        transition: 0.3s ease-in-out;
        opacity: 0;

        &.active {
            opacity: 1;
            transform: translate(-50%, -50%);
        }

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    &__content {
        padding: 0 2rem;
        overflow-y: auto;
        max-height: var(--preview-height);
    }

    &__header {
        position: sticky;
        top: 0;
        background-color: var(--color-white);
        z-index: 1;
        padding: 1.5rem 2rem;
    }

    &__footer {
        position: sticky;
        bottom: 0;
        background-color: var(--color-white);
        z-index: 1;
        padding: 1.5rem 2rem;
    }

    .modal-backdrop {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--color-primary);
        opacity: 0.5;
        z-index: -1;
    }

    .tns-controls {
        position: sticky;
        top: 50%;
        left: 0;
        right: 0;

        button {
            position: absolute;
            border: 0;
            font-size: 0;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='green' fill-rule='evenodd' d='M12.5 11.625 9 7.249 10.562 6l4.5 5.625-4.5 5.624L9 16l3.5-4.375z' clip-rule='evenodd'/%3E%3C/svg%3E");
            width: 64px;
            height: 64px;
            background-color: transparent;
            transform: translateY(-50%);
            outline: none;

            &:first-child {
                left: -52px;
                transform: translateY(-50%) rotate(180deg);
            }
            &:last-child {
                right: -52px;
            }
        }
    }
}
</style>
